import { getParamColumnsOptions } from "../../GridTools/parseColumnTools";
import { EditStyle, ParamSetOption, Prefixes } from "../../../Tools/ProjectX";
import { ObjType } from "../../../Tools/Consts";

const defaultFieldInfo = {
  options: getParamColumnsOptions(0),
  Values: [],
};

export function getPayTypesColumnsForSection(
  codeField: { displayWidth: string },
  json?: { EtalonEditStyle?: string; EtalonModule?: string; EtalonObjType?: string },
) {
  const hasEtalon = json?.EtalonObjType !== undefined;
  return {
    title: [
      {
        fieldName: "Code",
        title: "Код",
        width: codeField ? codeField.displayWidth * 15 : 120,
        level: 0,
        fieldInfo: {
          ...defaultFieldInfo,
          options: getParamColumnsOptions(ParamSetOption.Fixed),
          editMask: "0.0.0.0.0000",
        },
        collapseRecord: true,
      },
      {
        fieldName: "Name",
        title: "Наименование",
        width: 200,
        level: 0,
        fieldInfo: { ...defaultFieldInfo },
      },
      {
        fieldName: "Etalon",
        title: "Эталонный справочник",
        width: 200,
        level: 0,
        hide: !hasEtalon,
        hideInGrid: !hasEtalon,
        hideInCard: !hasEtalon,
        fieldInfo: {
          ...defaultFieldInfo,
          Module: json?.EtalonModule,
          EditStyle: json?.EtalonEditStyle,
          DataType: json?.EtalonObjType,
        },
      },
      {
        fieldName: "ShortName",
        title: "Сокращение",
        width: 120,
        level: 0,
        fieldInfo: { ...defaultFieldInfo, EditStyle: "64" },
      },
      {
        fieldName: "Title",
        title: "Заголовок",
        width: 120,
        level: 0,
        fieldInfo: { ...defaultFieldInfo },
      },
      {
        fieldName: "ShortCode",
        title: "Краткий код",
        width: 120,
        level: 0,
        fieldInfo: { ...defaultFieldInfo },
      },
      {
        fieldName: "ImageIndex",
        title: "Рисунок",
        width: 120,
        level: 0,
        fieldInfo: { ...defaultFieldInfo, EditStyle: EditStyle.UpDown, type: "Image" },
      },
      {
        fieldName: "Параметры",
        title: "Набор параметров",
        width: 120,
        level: 0,
        fieldInfo: {
          ...defaultFieldInfo,
          EditStyle: EditStyle.Ellipsis,
          DataType: ObjType.ParamSet,
          Module: Prefixes.params,
        },
      },
      {
        fieldName: "Атрибуты",
        title: "Атрибуты",
        width: 120,
        level: 0,
        fieldInfo: {
          ...defaultFieldInfo,
          EditStyle: EditStyle.PickList + EditStyle.CheckList,
          DataType: "2380",
          Module: "paytypes",
        },
      },
    ],
  };
}

export const payTypesColumnsForPrograms = {
  title: [
    {
      fieldName: "Code2",
      title: "Вид оплаты",
      width: 120,
      level: 0,
      fieldInfo: {
        ...defaultFieldInfo,
        EditStyle: "17",
        Module: "paytypes",
        DataType: "2380",
      },
    },
    {
      fieldName: "ProgID",
      title: "Программа",
      width: 300,
      level: 0,
      fieldInfo: {
        ...defaultFieldInfo,
        EditStyle: "17",
        Module: "programs",
        DataType: "2001",
      },
    },
  ],
};

export const payTypesSettingsColumns = {
  title: [
    {
      fieldName: "ID",
      title: "ID",
      width: 60,
      level: 0,
      hide: true,
      hideInGrid: true,
      hideInCard: true,
      fieldInfo: { ...defaultFieldInfo },
    },
    {
      fieldName: "Code",
      title: "Код",
      width: 60,
      level: 0,
      fieldInfo: { ...defaultFieldInfo },
    },
    {
      fieldName: "Name",
      title: "Наименование",
      width: 300,
      level: 0,
      fieldInfo: { ...defaultFieldInfo },
    },
    {
      fieldName: "Deep",
      title: "Deep",
      width: 30,
      level: 0,
      fieldInfo: { ...defaultFieldInfo },
    },
    {
      fieldName: "ImageIndex",
      title: "ImageIndex",
      width: 30,
      level: 0,
      fieldInfo: { ...defaultFieldInfo, type: "Image" },
    },
    {
      fieldName: "Options",
      title: "Параметры",
      width: 300,
      level: 0,
      fieldInfo: { ...defaultFieldInfo, EditStyle: "32", Values: [{ label: "Суммировать по сотрудникам", id: 1 }] },
    },
    {
      fieldName: "OnGetAmount",
      title: "Получить сумму",
      width: 120,
      level: 1,
      fieldInfo: { ...defaultFieldInfo, EditStyle: "17", Module: "Programs", DataType: "2001" },
    },
    {
      fieldName: "OnSetAmount",
      title: "Установить сумму",
      width: 120,
      level: 1,
      fieldInfo: { ...defaultFieldInfo, EditStyle: "17", Module: "Programs", DataType: "2001" },
    },
    {
      fieldName: "ParamSetID",
      title: "Раскладка",
      width: 120,
      level: 1,
      fieldInfo: { ...defaultFieldInfo, EditStyle: "16", Module: "Params", DataType: "2789" },
    },
  ],
};
